/* eslint-disable @typescript-eslint/no-non-null-assertion */
import type { UserResource, UserIdentityMetadataResource, IdentityMetadataResource } from "@octopusdeploy/octopus-server-client";
import { repository, session } from "~/clientInstance";
import { isFeatureToggleEnabled } from "~/components/FeatureToggle/New/FeatureToggleContext";

export const isOctopusIdEnabled = async (): Promise<boolean> => {
    const currentUserId = session && session.currentUser ? session.currentUser.Id : null;
    const configDoc = await repository.UserIdentityMetadata.authenticationConfiguration(currentUserId!);
    return !!configDoc.AuthenticationProviders && !!configDoc.AuthenticationProviders.find((p) => p.Name === "Octopus ID");
};

/**
 * Indicates if the given user is managed by an external system via [SCIM](https://scim.cloud/).
 * @param user The user to check, or null.
 * @param userIdentityMetadata Metadata about the user's identities.
 * @returns true if the user has an identity of a provider that has SCIM enabled; otherwise false.
 */
export const isManagedByScim = (user: UserResource | null, userIdentityMetadata: UserIdentityMetadataResource) => {
    if (!user || !isFeatureToggleEnabled("ScimFeatureToggle")) {
        return false;
    }

    const userIsManagedByProvider = (provider: IdentityMetadataResource) => user.Identities.some((identity) => identity.IdentityProviderName === provider.IdentityProviderName);
    return userIdentityMetadata.Providers.some((provider) => provider.ScimEnabled && userIsManagedByProvider(provider));
};
